var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.847,
    height: 27.796,
    viewBox: "0 0 20.847 27.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 -0.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_217",
    d: "M1.807,1.807V25.99H19.041V1.807H1.807M0,0H20.847V27.8H0Z",
    transform: "translate(0 0.043)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_7",
    d: "M15.229,5.657H5.5V3.85h9.729Z",
    transform: "translate(2.144 1.544)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    d: "M15.229,9.157H5.5V7.35h9.729Z",
    transform: "translate(2.144 2.908)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    d: "M15.229,12.657H5.5V10.85h9.729Z",
    transform: "translate(2.144 4.272)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_13",
    d: "M15.229,16.157H5.5V14.35h9.729Z",
    transform: "translate(2.144 5.637)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    d: "M4.585,12.657H2.5V10.85H4.585Z",
    transform: "translate(0.975 4.272)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_14",
    d: "M4.585,16.157H2.5V14.35H4.585Z",
    transform: "translate(0.975 5.637)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_11",
    d: "M4.585,9.157H2.5V7.35H4.585Z",
    transform: "translate(0.975 2.908)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_12",
    d: "M4.585,5.657H2.5V3.85H4.585Z",
    transform: "translate(0.975 1.544)",
    fill: "#92d4d0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.76a2a89dfd642e509c9183a57de07052.svg";
export { ForwardRef as ReactComponent };